Object.defineProperty(module.exports, "__esModule", {
  value: true
})

module.exports.default = function(tokens) {
  return {
    inputSpacingVertical: 0,
    inputSpacingInsetVerticalDefault: 0,
    inputSpacingInsetVerticalAuto: 12,
    inputSpacingInsetHorizontal: 12,
    inputHeightSmall: 32,
    inputHeightMedium: 40,
    inputHeightLarge: 48,
    inputHeightXlarge: 60,
    inputForegroundColorDefault: tokens.themeInkDefault,
    inputForegroundColorDisabled: tokens.themeInkDisabled,
    inputPlaceholderColorDefault: tokens.themeInkSubdued,
    inputPlaceholderColorDisabled: tokens.themeInkDisabled,
    inputBorderWidth: 1,
    inputBorderRadius: 4,
    inputBorderColorDefault: tokens.themeBorderFormfield,
    inputBorderColorDisabled: tokens.themeBorderDisabled,
    inputFocusRingBorderWidth: 1,
    inputFocusRingBorderRadius: 4,
    inputBackgroundColorDefault: tokens.themePageDefault,
    inputBackgroundColorDisabled: tokens.themeSurfaceDisabled,
    inputTextSmallFontSize: 14,
    inputTextSmallFontWeight: 400,
    inputTextSmallLineHeight: "20px",
    inputTextMediumFontSize: 16,
    inputTextMediumFontWeight: 400,
    inputTextMediumLineHeight: "24px",
    inputTextLargeFontSize: 16,
    inputTextLargeFontWeight: 400,
    inputTextLargeLineHeight: "24px",
    inputTextXlargeFontSize: 16,
    inputTextXlargeFontWeight: 400,
    inputTextXlargeLineHeight: "24px",
    inputEndcapBorderWidth: 1,
    inputEndcapBorderRadius: 4,
    inputEndcapBackgroundColorDefault: tokens.themeDecorativeNeutralSubdued,
    inputEndcapBackgroundColorDisabled: tokens.themeActionSecondaryDisabled,
    inputEndcapForegroundColorDefault: tokens.themeInkDefault,
    inputEndcapForegroundColorDisabled: tokens.themeInkDisabled,
    inputLabelDefaultFontSize: 16,
    inputLabelDefaultFontWeight: 400,
    inputLabelDefaultLineHeight: "24px",
    inputLabelFloatedFontSize: 14,
    inputLabelFloatedFontWeight: 400,
    inputLabelFloatedLineHeight: "20px",
    inputLabelColorDefault: tokens.themeInkDefault,
    inputLabelColorFocus: tokens.themeActionPrimaryDefault,
    inputLabelColorDisabled: tokens.themeInkDisabled,
    inputLabelFloatDistanceXlarge: 12,
    inputLabelFloatDistanceAuto: 4,
    inputLabelMotionDuration: "150ms",
    inputLabelMotionFunction: "ease",
    inputFontSizeDefault: 16,
    inputFontSizeSmall: 14,
    inputLabelFontSizeDefault: 16,
    inputLabelFontSizeFloated: 14,
    inputLineHeightDefault: "20px",
    inputLineHeightAuto: "24px"
  }
};